import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "container py-5 text-center"
};
const _hoisted_2 = { class: "mb-3" };
import Store from '@vue/components/Store.vue';
import ReservationForm from '@vue/components/ReservationForm.vue';
import SearchList from '@vue/components/SearchList.vue';
import { MainStore } from '@vue/services/store';
import { onMounted, provide, ref, shallowRef } from 'vue';
import { $lang } from '@vue/services/utilities';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReservationApp',
    props: {
        locale: {},
        brandId: {},
        storeId: {},
        privacyUrl: {},
        brandLocked: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        MainStore.brandId = props.brandId;
        MainStore.storeId = props.storeId;
        provide('locale', props.locale);
        provide('privacyUrl', props.privacyUrl);
        // 單品牌站（.env SITE_BRAND_ID）：不顯示品牌下拉，見 loadBrands / loadStores 的過濾。
        provide('brandLocked', props.brandLocked === true);
        const brands = ref([]);
        const stores = ref([]);
        const viewComponent = shallowRef();
        const loadFailed = ref(false);
        onMounted(async () => {
            viewComponent.value = SearchList;
            await loadBase();
        });
        // 品牌／門市清單載入失敗：原本例外沒人接，畫面停在空白清單、沒有訊息也不能重試
        // （v1.8.7.3 驗收第 4 節）。請求本身的上限由 axios 逾時負責。
        async function loadBase() {
            loadFailed.value = false;
            try {
                await loadBrands();
                await loadStores();
            }
            catch (e) {
                loadFailed.value = true;
            }
        }
        // 本站（明水然系）訂位流程僅服務 明水然(1) / 明水然・樂(2)。
        // 採「白名單」而非黑名單：未來 DB 新增的肉多多/新肉多多/狂一鍋等品牌（分站經營）
        // 不會汙染本站訂位流程。若要在本站新增品牌，明確加入此清單即可。
        const ALLOWED_BRAND_IDS = [1, 2];
        // 單品牌站再收斂一層：只留本站品牌，另一品牌的門市不會出現在清單、也切換不到。
        const allowedBrandIds = props.brandLocked === true ? [props.brandId] : ALLOWED_BRAND_IDS;
        async function loadBrands() {
            const res = await u.$http.get('front/reserve/loadBrands');
            brands.value = res.data.data.items
                .filter((b) => allowedBrandIds.includes(b.id));
        }
        async function loadStores() {
            const res = await u.$http.get('front/reserve/loadStores');
            stores.value = res.data.data.items
                .filter((s) => allowedBrandIds.includes(s.brandId));
        }
        async function toReservationForm(v) {
            Object.keys(v).forEach((k) => {
                MainStore[k] = v[k];
            });
            viewComponent.value = ReservationForm;
        }
        async function toSearchList() {
            viewComponent.value = SearchList;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (loadFailed.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref($lang)('app.reservation.load.failed')), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary",
                            onClick: loadBase
                        }, _toDisplayString(_unref($lang)('app.reservation.load.retry')), 1)
                    ]))
                    : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_resolveDynamicComponent(viewComponent.value), {
                    brands: brands.value,
                    stores: stores.value,
                    onToReservationForm: toReservationForm,
                    onToSearchList: toSearchList
                }, null, 40, ["brands", "stores"])),
                _createVNode(Store)
            ]));
        };
    }
});
